import React from 'react';
import {
  ARCHIVED_TABS,
  LISTING_STATUS,
  PENDING_INTAKE_TABS,
  PENDING_REVIEW_TABS,
  SELL_AS_IS_TABS,
} from '../constants/listing';
import { FormattedMessage } from 'react-intl';
import { createResourceLocatorString } from './routes';
import { isUserVerifiedCompanyDealer, isUserVerifiedHQ } from './user';

export const getArchivedTabs = (
  selectedArchivedTab,
  setState,
  history,
  routes,
  selectedView,
  archivedCounts,
  currentUser,
  normalizedProductType
) => [
  {
    text: (
      <div>
        <FormattedMessage id="General.bought" />
        <span>({archivedCounts?.bought || 0})</span>
      </div>
    ),
    selected: selectedArchivedTab === ARCHIVED_TABS.BOUGHT,
    onClick: () => {
      let updatedQueryParams = {
        archived: true,
        meta_status: undefined,
        tab: ARCHIVED_TABS.BOUGHT,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      if (isUserVerifiedHQ(currentUser)) {
        updatedQueryParams = { ...updatedQueryParams, meta_buyerCompanyName: 'Husqvarna' };
      } else if (isUserVerifiedCompanyDealer(currentUser)) {
        updatedQueryParams = {
          ...updatedQueryParams,
        };
      }

      setState({
        selectedArchivedTab: ARCHIVED_TABS.BOUGHT,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="General.sold" />
        <span>({archivedCounts?.sold || 0})</span>
      </div>
    ),
    selected: selectedArchivedTab === ARCHIVED_TABS.SOLD,
    onClick: () => {
      const updatedQueryParams = {
        archived: true,
        meta_status: LISTING_STATUS.SOLD,
        tab: ARCHIVED_TABS.SOLD,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        meta_isBuyerConfirmPending: false,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedArchivedTab: ARCHIVED_TABS.SOLD,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="General.scrapped" />
        <span>({archivedCounts?.scrapped || 0})</span>
      </div>
    ),
    selected: selectedArchivedTab === ARCHIVED_TABS.SCRAPPED,
    onClick: () => {
      const updatedQueryParams = {
        archived: true,
        meta_status: LISTING_STATUS.SCRAPPED,
        tab: ARCHIVED_TABS.SCRAPPED,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedArchivedTab: ARCHIVED_TABS.SCRAPPED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="General.buyOutOrProlong" />
        <span>({archivedCounts?.buyOutOrProlonged || 0})</span>
      </div>
    ),
    selected: selectedArchivedTab === ARCHIVED_TABS.BUY_OUT_OR_PROLONG,
    onClick: () => {
      const updatedQueryParams = {
        archived: true,
        meta_status: undefined,
        meta_leaseExpirationOption: 'customerBuyOut,prolongLeasing',
        tab: ARCHIVED_TABS.BUY_OUT_OR_PROLONG,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedArchivedTab: ARCHIVED_TABS.BUY_OUT_OR_PROLONG,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
];

export const getPendingIntakeTabs = (
  selectedPendingIntakeTab,
  locationSearch,
  setState,
  history,
  routes,
  selectedView,
  contractExpirationCounts,
  menuCounts,
  normalizedProductType
) => [
  {
    text: (
      <div>
        <FormattedMessage id="SearchPage.all" />
        <span>
          (
          {locationSearch?.pendingIntakeState === 'soon'
            ? menuCounts?.endingSoon || 0
            : menuCounts?.expired || 0}
          )
        </span>
      </div>
    ),
    selected: selectedPendingIntakeTab === PENDING_INTAKE_TABS.ALL,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PENDING_INTAKE,
        pendingIntakeState: locationSearch?.pendingIntakeState,
        tab: PENDING_INTAKE_TABS.ALL,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedPendingIntakeTab: PENDING_INTAKE_TABS.ALL,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="SearchPage.customerNotContacted" />
        <span>({contractExpirationCounts?.customerNotContacted || 0})</span>
      </div>
    ),
    selected: selectedPendingIntakeTab === PENDING_INTAKE_TABS.CUSTOMER_NOT_CONTACTED,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PENDING_INTAKE,
        meta_hasContactedLeasingUser: false,
        pendingIntakeState: locationSearch?.pendingIntakeState,
        tab: PENDING_INTAKE_TABS.CUSTOMER_NOT_CONTACTED,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedPendingIntakeTab: PENDING_INTAKE_TABS.CUSTOMER_NOT_CONTACTED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="SearchPage.customerContacted" />
        <span>({contractExpirationCounts?.customerContacted || 0})</span>
      </div>
    ),
    selected: selectedPendingIntakeTab === PENDING_INTAKE_TABS.CUSTOMER_CONTACTED,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PENDING_INTAKE,
        meta_hasContactedLeasingUser: true,
        meta_leaseExpirationOption: 'not-set',
        pendingIntakeState: locationSearch?.pendingIntakeState,
        tab: PENDING_INTAKE_TABS.CUSTOMER_CONTACTED,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedPendingIntakeTab: PENDING_INTAKE_TABS.CUSTOMER_CONTACTED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="SearchPage.customerResponded" />
        <span>({contractExpirationCounts?.customerResponded || 0})</span>
      </div>
    ),
    selected: selectedPendingIntakeTab === PENDING_INTAKE_TABS.CUSTOMER_RESPONDED,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PENDING_INTAKE,
        meta_leaseExpirationOption: 'nothing,newLeasingOffering,customerBuyOut,prolongLeasing',
        pendingIntakeState: locationSearch?.pendingIntakeState,
        tab: PENDING_INTAKE_TABS.CUSTOMER_RESPONDED,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedPendingIntakeTab: PENDING_INTAKE_TABS.CUSTOMER_RESPONDED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
];

export const getContractYearTabs = (
  selectedYearTab,
  locationSearch,
  setState,
  history,
  routes,
  selectedView
) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => currentYear + i);

  const tabs = [];

  tabs.push({
    text: <div>All</div>,
    selected: selectedYearTab === 'all',
    onClick: () => {
      const updatedQueryParams = {
        ...locationSearch,
        [`pub_contractEndDateTimestamp`]: undefined,
        tab: 'all',
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
      };

      setState({
        selectedPendingIntakeYearTab: 'all',
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  });

  const yearTabs = years.map(year => {
    const from = new Date(`${year}-01-01T00:00:00Z`).getTime();
    const to = new Date(`${year + 1}-01-01T00:00:00Z`).getTime();

    return {
      text: <div>{year}</div>,
      selected: selectedYearTab === `year-${year}`,
      onClick: () => {
        const updatedQueryParams = {
          ...locationSearch,
          [`pub_contractEndDateTimestamp`]: `${from},${to}`,
          tab: `year-${year}`,
          view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        };

        setState({
          selectedPendingIntakeYearTab: `year-${year}`,
          currentQueryParams: updatedQueryParams,
        });

        history.replace(
          createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
        );
      },
    };
  });

  return [...tabs, ...yearTabs];
};

export const getPendingReviewTabs = (
  selectedPendingReviewTab,
  setState,
  history,
  routes,
  currentUser,
  selectedView,
  normalizedProductType
) => [
  {
    text: (
      <div>
        <FormattedMessage id="SearchPage.all" />
      </div>
    ),
    selected: selectedPendingReviewTab === PENDING_REVIEW_TABS.ALL,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PENDING_REVIEW,
        tab: PENDING_REVIEW_TABS.ALL,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedPendingReviewTab: PENDING_REVIEW_TABS.ALL,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="SearchPage.ownedByMe" />
      </div>
    ),
    selected: selectedPendingReviewTab === PENDING_REVIEW_TABS.OWNED_BY_ME,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PENDING_REVIEW,
        meta_contractEndOwnerCompanyId: currentUser?.attributes?.profile?.publicData?.companyId,
        tab: PENDING_REVIEW_TABS.OWNED_BY_ME,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedPendingReviewTab: PENDING_REVIEW_TABS.OWNED_BY_ME,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="SearchPage.ownedByHusqvarna" />
      </div>
    ),
    selected: selectedPendingReviewTab === PENDING_REVIEW_TABS.OWNED_BY_HUSQVARNA,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PENDING_REVIEW,
        meta_contractEndOwnerCompanyName: 'Husqvarna',
        tab: PENDING_REVIEW_TABS.OWNED_BY_HUSQVARNA,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedPendingReviewTab: PENDING_REVIEW_TABS.OWNED_BY_HUSQVARNA,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
];

export const getForSaleTabs = (
  selectedForSaleTab,
  setState,
  history,
  routes,
  selectedView,
  forSaleCounts,
  normalizedProductType
) => [
  {
    text: (
      <div>
        <FormattedMessage id="General.published" />
        <span>({forSaleCounts?.published || 0})</span>
      </div>
    ),
    selected: selectedForSaleTab === LISTING_STATUS.PUBLISHED,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.PUBLISHED,
        forSale: true,
        tab: LISTING_STATUS.PUBLISHED,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        meta_isBuyerConfirmPending: undefined,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedForSaleTab: LISTING_STATUS.PUBLISHED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    text: (
      <div>
        <FormattedMessage id="General.sold" />
        <span>({forSaleCounts?.sold || 0})</span>
      </div>
    ),
    selected: selectedForSaleTab === LISTING_STATUS.SOLD,
    onClick: () => {
      const updatedQueryParams = {
        meta_status: LISTING_STATUS.SOLD,
        forSale: true,
        tab: LISTING_STATUS.SOLD,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        meta_isBuyerConfirmPending: false,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedForSaleTab: LISTING_STATUS.SOLD,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
];

export const getSellAsIsTabs = (
  selectedSellAsIsTab,
  locationSearch,
  setState,
  history,
  routes,
  selectedView,
  buyingAsIsCounts,
  sellingAsIsCounts,
  normalizedProductType
) => [
  {
    id: 'forSale',
    text: (
      <div>
        <FormattedMessage id="General.forSale" />
        <span>
          (
          {locationSearch?.sellAsIsState === 'buying'
            ? buyingAsIsCounts?.forSale || 0
            : sellingAsIsCounts?.forSale || 0}
          )
        </span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.FOR_SALE,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: LISTING_STATUS.SELL_AS_IS,
        sellAsIsState: locationSearch?.sellAsIsState,
        tab: SELL_AS_IS_TABS.FOR_SALE,
        owned: false,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.FOR_SALE,
        currentQueryParams: updatedQueryParams,
      });
      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'pendingSold',
    text: (
      <div>
        <FormattedMessage id="General.pendingSold" />
        <span>
          (
          {locationSearch?.sellAsIsState === 'buying'
            ? buyingAsIsCounts?.pendingSold || 0
            : sellingAsIsCounts?.pendingSold || 0}
          )
        </span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.PENDING_SOLD,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: undefined,
        meta_isBuyerConfirmPending: undefined,
        sellAsIsState: locationSearch?.sellAsIsState,
        tab: SELL_AS_IS_TABS.PENDING_SOLD,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.PENDING_SOLD,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'bought',
    text: (
      <div>
        <FormattedMessage id="General.bought" />
        <span>({buyingAsIsCounts?.bought || 0})</span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.BOUGHT,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: undefined,
        sellAsIsState: locationSearch?.sellAsIsState,
        tab: SELL_AS_IS_TABS.BOUGHT,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.BOUGHT,
        currentQueryParams: updatedQueryParams,
      });
      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'sold',
    text: (
      <div>
        <FormattedMessage id="General.sold" />
        <span>({sellingAsIsCounts?.sold || 0})</span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.SOLD,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: LISTING_STATUS.SOLD,
        meta_isBuyerConfirmPending: false,
        sellAsIsState: locationSearch?.sellAsIsState,
        tab: SELL_AS_IS_TABS.SOLD,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.SOLD,
        currentQueryParams: updatedQueryParams,
      });
      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'shipped',
    text: (
      <div>
        <FormattedMessage id="General.shipped" />
        <span>
          (
          {locationSearch?.sellAsIsState === 'buying'
            ? buyingAsIsCounts?.shipped || 0
            : sellingAsIsCounts?.shipped || 0}
          )
        </span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.SHIPPED,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: LISTING_STATUS.SOLD,
        meta_shipped: true,
        sellAsIsState: locationSearch?.sellAsIsState,
        tab: SELL_AS_IS_TABS.SHIPPED,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.SHIPPED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'received',
    text: (
      <div>
        <FormattedMessage id="General.received" />
        <span>
          (
          {locationSearch?.sellAsIsState === 'buying'
            ? buyingAsIsCounts?.received || 0
            : sellingAsIsCounts?.received || 0}
          )
        </span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.RECEIVED,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: LISTING_STATUS.PENDING_REVIEW,
        sellAsIsState: locationSearch?.sellAsIsState,
        tab: SELL_AS_IS_TABS.RECEIVED,
        view: !selectedView || selectedView === 'grid' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.RECEIVED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageMyListings', routes, {}, updatedQueryParams)
      );
    },
  },
];

export const getBuyingSellAsIsTabs = (
  selectedSellAsIsTab,
  setState,
  history,
  routes,
  selectedView,
  buyingAsIsCounts,
  normalizedProductType
) => [
  {
    id: 'forSale',
    text: (
      <div>
        <FormattedMessage id="General.forSale" />
        <span>({buyingAsIsCounts?.forSale || 0})</span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.FOR_SALE,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: LISTING_STATUS.SELL_AS_IS,
        sellAsIsState: 'buying',
        tab: SELL_AS_IS_TABS.FOR_SALE,
        owned: false,
        view: !selectedView || selectedView === 'map' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.FOR_SALE,
        currentQueryParams: updatedQueryParams,
      });
      history.replace(
        createResourceLocatorString('SearchPageSellAsIs', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'pendingSold',
    text: (
      <div>
        <FormattedMessage id="General.pendingSold" />
        <span>({buyingAsIsCounts?.pendingSold || 0})</span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.PENDING_SOLD,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: undefined,
        meta_isBuyerConfirmPending: undefined,
        sellAsIsState: 'buying',
        tab: SELL_AS_IS_TABS.PENDING_SOLD,
        view: !selectedView || selectedView === 'map' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.PENDING_SOLD,
        currentQueryParams: updatedQueryParams,
      });

      console.log({ updatedQueryParams });

      history.replace(
        createResourceLocatorString('SearchPageSellAsIs', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'bought',
    text: (
      <div>
        <FormattedMessage id="General.bought" />
        <span>({buyingAsIsCounts?.bought || 0})</span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.BOUGHT,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: undefined,
        sellAsIsState: 'buying',
        tab: SELL_AS_IS_TABS.BOUGHT,
        view: !selectedView || selectedView === 'map' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.BOUGHT,
        currentQueryParams: updatedQueryParams,
      });
      history.replace(
        createResourceLocatorString('SearchPageSellAsIs', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'shipped',
    text: (
      <div>
        <FormattedMessage id="General.shipped" />
        <span>({buyingAsIsCounts?.shipped || 0})</span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.SHIPPED,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: LISTING_STATUS.SOLD,
        meta_shipped: true,
        sellAsIsState: 'buying',
        tab: SELL_AS_IS_TABS.SHIPPED,
        view: !selectedView || selectedView === 'map' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.SHIPPED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageSellAsIs', routes, {}, updatedQueryParams)
      );
    },
  },
  {
    id: 'received',
    text: (
      <div>
        <FormattedMessage id="General.received" />
        <span>({buyingAsIsCounts?.received || 0})</span>
      </div>
    ),
    selected: selectedSellAsIsTab === SELL_AS_IS_TABS.RECEIVED,
    onClick: () => {
      const updatedQueryParams = {
        asIs: true,
        meta_status: LISTING_STATUS.PENDING_REVIEW,
        sellAsIsState: 'buying',
        tab: SELL_AS_IS_TABS.RECEIVED,
        view: !selectedView || selectedView === 'map' ? undefined : selectedView,
        ...(normalizedProductType ? { pub_productType: normalizedProductType } : {}),
      };

      setState({
        selectedSellAsIsTab: SELL_AS_IS_TABS.RECEIVED,
        currentQueryParams: updatedQueryParams,
      });

      history.replace(
        createResourceLocatorString('SearchPageSellAsIs', routes, {}, updatedQueryParams)
      );
    },
  },
];
